import arrowCircleDownIcon from './icons/arrow-circle-down';
import arrowCircleLeftIcon from './icons/arrow-circle-left';
import arrowCircleRightIcon from './icons/arrow-circle-right';
import bellIcon from './icons/bell';
import binIcon from './icons/bin';
import bookIcon from './icons/book';
import calendarIcon from './icons/calendar';
import cameraIcon from './icons/camera';
import cartIcon from './icons/cart';
import chartIcon from './icons/chart';
import checkIcon from './icons/check';
import checkmarkIcon from './icons/checkmark';
import chevronDownIcon from './icons/chevron-down';
import chevronLeftIcon from './icons/chevron-left';
import chevronLeftX2Icon from './icons/chevron-left-2x';
import chevronRightIcon from './icons/chevron-right';
import chevronRightX2Icon from './icons/chevron-right-2x';
import chevronUpIcon from './icons/chevron-up';
import cloudIcon from './icons/cloud';
import cogIcon from './icons/cog';
import copyIcon from './icons/copy';
import creditCardIcon from './icons/credit-card';
import cubeIcon from './icons/cube';
import discordIcon from './icons/discord';
import downloadCloudIcon from './icons/download-cloud';
import downloadIcon from './icons/download';
import editIcon from './icons/edit';
import exclamationIcon from './icons/exclamation';
import expandIcon from './icons/expand';
import externalLinkIcon from './icons/external-link';
import eyeClosedIcon from './icons/eye-closed';
import eyeIcon from './icons/eye';
import fileIcon from './icons/file';
import githubIcon from './icons/github';
import gridIcon from './icons/grid';
import helpCircleIcon from './icons/help-circle';
import imageIcon from './icons/image';
import infoIcon from './icons/info';
import lifeRingIcon from './icons/life-ring';
import linkIcon from './icons/link';
import linuxIcon from './icons/linux';
import listIcon from './icons/list';
import lockClosedIcon from './icons/lock-closed';
import lockOpenIcon from './icons/lock-open';
import logOutIcon from './icons/log-out';
import mailIcon from './icons/mail';
import maximizeIcon from './icons/maximize';
import messageCircleIcon from './icons/message-circle';
import minimizeIcon from './icons/minimize';
import minusIcon from './icons/minus';
import monitorIcon from './icons/monitor';
import moreIcon from './icons/more';
import moreVertIcon from './icons/more-vert';
import networkIcon from './icons/network';
import offIcon from './icons/off';
import paperclipIcon from './icons/paperclip';
import pinIcon from './icons/pin';
import plugIcon from './icons/plug';
import plusIcon from './icons/plus';
import pulseIcon from './icons/pulse';
import redditIcon from './icons/reddit';
import reloadIcon from './icons/reload';
import searchIcon from './icons/search';
import serverIcon from './icons/server';
import starIcon from './icons/star';
import starsIcon from './icons/stars';
import telegramIcon from './icons/telegram';
import testnetIcon from './icons/testnet';
import triangleDownIcon from './icons/triangle-down';
import triangleUpIcon from './icons/triangle-up';
import twitterIcon from './icons/twitter';
import updateIcon from './icons/update';
import userIcon from './icons/user';
import windowsIcon from './icons/windows';
import btcIcon from './icons/btc';
import bnbIcon from './icons/bnb';
import oneinchIcon from './icons/oneinch';
import shibIcon from './icons/shib';
import dogeIcon from './icons/doge';
import ethIcon from './icons/eth';
import filIcon from './icons/fil';
import maticIcon from './icons/matic';
import avaxIcon from './icons/avax';
import uniIcon from './icons/uni';
import chainlinkIcon from './icons/chainlink';
import xrpIcon from './icons/xrp';
import adaIcon from './icons/ada';
import dappsIcon from './icons/dapps';
import speedyNodeIcon from './icons/speedyNode';
import usdtIcon from './icons/usdt';
import usdcIcon from './icons/usdc';
import xCircleIcon from './icons/x-circle';
import xIcon from './icons/x';
import youtubeIcon from './icons/youtube';
import web3apiIcon from './icons/web3api';
import atomicApiIcon from './icons/atomicApi';

export type TIconType = keyof typeof iconTypes;

export const iconTypes = {
    ada: 'ada',
    arrowCircleDown: 'arrowCircleDown',
    arrowCircleLeft: 'arrowCircleLeft',
    arrowCircleRight: 'arrowCircleRight',
    atomicApi: 'atomicApi',
    avax: 'avax',
    bell: 'bell',
    bin: 'bin',
    bnb: 'bnb',
    book: 'book',
    btc: 'btc',
    calendar: 'calendar',
    camera: 'camera',
    cart: 'cart',
    chainlink: 'chainlink',
    chart: 'chart',
    check: 'check',
    checkmark: 'checkmark',
    chevronDown: 'chevronDown',
    chevronLeft: 'chevronLeft',
    chevronLeftX2: 'chevronLeftX2',
    chevronRight: 'chevronRight',
    chevronRightX2: 'chevronRightX2',
    chevronUp: 'chevronUp',
    cloud: 'cloud',
    cog: 'cog',
    copy: 'copy',
    creditCard: 'credit card',
    cube: 'cube',
    dapps: 'dapps',
    discord: 'discord',
    doge: 'doge',
    download: 'download',
    downloadCloud: 'downloadCloud',
    edit: 'edit',
    eth: 'eth',
    exclamation: 'exclamation',
    expand: 'expand',
    externalLink: 'externalLink',
    eye: 'eye',
    eyeClosed: 'eyeClosed',
    fil: 'fil',
    file: 'file',
    github: 'github',
    grid: 'grid',
    helpCircle: 'helpCircle',
    image: 'image',
    info: 'info',
    lifeRing: 'lifeRing',
    link: 'link',
    linux: 'linux',
    list: 'list',
    lockClosed: 'lockClosed',
    lockOpen: 'lockOpen',
    logOut: 'logOut',
    mail: 'mail',
    matic: 'matic',
    maximize: 'maximize',
    messageCircle: 'messageCircle',
    minimize: 'minimize',
    minus: 'minus',
    monitor: 'monitor',
    more: 'more',
    moreVert: 'moreVert',
    network: 'network',
    off: 'off',
    oneinch: 'oneinch',
    paperclip: 'paperclip',
    pin: 'pin',
    plug: 'plug',
    plus: 'plus',
    pulse: 'pulse',
    reddit: 'reddit',
    reload: 'reload',
    search: 'search',
    server: 'server',
    shib: 'shib',
    speedyNode: 'speedyNode',
    star: 'star',
    stars: 'stars',
    telegram: 'telegram',
    testnet: 'testnet',
    triangleDown: 'triangleDown',
    triangleUp: 'triangleUp',
    twitter: 'twitter',
    uni: 'uni',
    update: 'update',
    usdc: 'usdc',
    usdt: 'usdt',
    user: 'user',
    web3api: 'web3api',
    windows: 'windows',
    x: 'x',
    xCircle: 'xCircle',
    xrp: 'xrp',
    youtube: 'youtube',
} as const;

const collection = {
    adaIcon,
    arrowCircleDownIcon,
    arrowCircleLeftIcon,
    arrowCircleRightIcon,
    atomicApiIcon,
    avaxIcon,
    bellIcon,
    binIcon,
    bnbIcon,
    bookIcon,
    btcIcon,
    calendarIcon,
    cameraIcon,
    cartIcon,
    chainlinkIcon,
    chartIcon,
    checkIcon,
    checkmarkIcon,
    chevronDownIcon,
    chevronLeftIcon,
    chevronLeftX2Icon,
    chevronRightIcon,
    chevronRightX2Icon,
    chevronUpIcon,
    cloudIcon,
    cogIcon,
    copyIcon,
    creditCardIcon,
    cubeIcon,
    dappsIcon,
    discordIcon,
    dogeIcon,
    downloadCloudIcon,
    downloadIcon,
    editIcon,
    ethIcon,
    exclamationIcon,
    expandIcon,
    externalLinkIcon,
    eyeClosedIcon,
    eyeIcon,
    fileIcon,
    filIcon,
    githubIcon,
    gridIcon,
    helpCircleIcon,
    imageIcon,
    infoIcon,
    lifeRingIcon,
    linkIcon,
    linuxIcon,
    listIcon,
    lockClosedIcon,
    lockOpenIcon,
    logOutIcon,
    mailIcon,
    maticIcon,
    maximizeIcon,
    messageCircleIcon,
    minimizeIcon,
    minusIcon,
    monitorIcon,
    moreIcon,
    moreVertIcon,
    networkIcon,
    offIcon,
    oneinchIcon,
    paperclipIcon,
    pinIcon,
    plugIcon,
    plusIcon,
    pulseIcon,
    redditIcon,
    reloadIcon,
    searchIcon,
    serverIcon,
    shibIcon,
    speedyNodeIcon,
    starIcon,
    starsIcon,
    telegramIcon,
    testnetIcon,
    triangleDownIcon,
    triangleUpIcon,
    twitterIcon,
    uniIcon,
    updateIcon,
    usdcIcon,
    usdtIcon,
    userIcon,
    web3apiIcon,
    windowsIcon,
    xCircleIcon,
    xIcon,
    xrpIcon,
    youtubeIcon,
};

export default collection;
